/**
 * An ISO date-time's wall-clock digits, read AS UTC (see formatDateTimeString.ts
 * for why that is relied on).
 *
 * ⚠ The fractional seconds are a FRACTION, not a millisecond count. The API sends
 * microseconds (`20:17:47.393123Z`), and passing those six digits to `Date.UTC`
 * as milliseconds added 393 SECONDS -- up to ~16 minutes on every displayed time,
 * a different amount per value. Two timestamps a few ms apart could then render
 * minutes apart and in the wrong order: the Case thread showed a reply's Created
 * line AFTER its Last Edited one. So the fraction is scaled to exactly three
 * digits, whatever its length, and only when it follows a seconds field -- a bare
 * `\D+` split would read a `+05:00` offset as one.
 */
export function parseISOString(s: string) {
  const b = s.split(/\D+/).map(Number)
  const fraction = /:\d+\.(\d+)/.exec(s)?.[1] ?? ''
  const ms = Number(fraction.padEnd(3, '0').slice(0, 3))
  return new Date(Date.UTC(b[0], b[1] - 1, b[2], b[3], b[4], b[5], ms))
}
